import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { EN } from '../../../services/languages/constants'
import { PREVIEW_PLAYED_GA4_EVENT } from '../../../services/event-tracking/index'
import Button, { TYPES } from '../../Button/index'
import PreviewIcon from '../../Icon/icons/Preview/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3ActionTrailer
 */

const DetailPageV3ActionTrailer = (props) => {
  const {
    detailData = Map(),
    staticText,
    ga4EventData,
    setEventDefault,
  } = props

  const handleTrailerClick = () => {
    setEventDefault(PREVIEW_PLAYED_GA4_EVENT.mergeDeep({
      ...ga4EventData,
      media_id: detailData.get('previewMedia', 'mediaId'),
      media_language: detailData.get('languageFullText', EN),
      is_featured_media: false,
      ui_element: 'Jumbotron Detail Page',
    }))
  }

  if (!detailData.get('previewMedia')) {
    return null
  }

  return (
    <Button
      type={TYPES.ICON}
      iconSvg={<PreviewIcon size={32} />}
      onClick={handleTrailerClick}
      url={detailData.get('path')}
      query={{ fullplayer: 'preview' }}
      className="detail-page-v3__action-button"
    >
      <span className="detail-page-v3__action-label">
        {staticText.get('trailer')}
      </span>
    </Button>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3ActionTrailer)
